export function isNotNull<T>(value: T): value is Exclude<T, null> {
	return value !== null;
}

export function isNotUndefined<T>(value: T): value is Exclude<T, undefined> {
	return value !== undefined;
}

export function isNotNullOrUndefined<T>(value: T): value is Exclude<T, undefined | null> {
	return value !== undefined && value !== null;
}
export function isNullOrUndefined<T>(value: T | null | undefined): value is undefined | null {
	return value === undefined || value === null;
}

/**
 * Returns true if string is not undefined, null, and ''. False otherwise.
 */
export function stringNotEmpty(
	value: string | null | undefined,
): value is Exclude<string | null | undefined, undefined | null> {
	return value !== undefined && value !== null && value !== '';
}

export function stringIsEmpty(value: string | null | undefined): value is string | null | undefined {
	return !stringNotEmpty(value);
}

export type KeysOfT<T, U> = keyof { [K in keyof T]: T[K] extends U ? T[K] : never };
export type StringKeysOfT<T, U> = Extract<KeysOfT<T, U>, string>;
